module.exports = require('./helpers/bundle-url').getBundleURL('1D4ws') + "logo.7718c6df.svg";